module.exports = __webpack_public_path__ + "static/media/imo2.b5193b2a.png";